module.exports = __webpack_public_path__ + "img/v2.be934b61.png";